import { useCallback, useEffect, useMemo, useState, type ReactNode } from "react";
import { ThemeContext } from "./context";
import { readStoredTheme, writeStoredTheme, type Theme } from "./storage";

const THEME_COLOR: Record<Theme, string> = {
  dark: "#0c0e12",
  light: "#f4f5f8",
};

function applyThemeToDom(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", THEME_COLOR[theme]);
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => readStoredTheme() ?? "dark");

  const setTheme = useCallback((t: Theme) => {
    writeStoredTheme(t);
    setThemeState(t);
    applyThemeToDom(t);
  }, []);

  useEffect(() => {
    applyThemeToDom(theme);
  }, [theme]);

  const value = useMemo(() => ({ theme, setTheme }), [theme, setTheme]);

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
